import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';

import { EstructuraBase } from '../model-form/estructura-base';
import { DropdownService } from '../servicios/dropdown.service';

import { MomentDateAdapter } from '@angular/material-moment-adapter';

import * as _moment from 'moment';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

declare let $: any;

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD'
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY-MM-DD',
    dateA11yLabel: 'YYYY-MM-DD',
    monthYearA11yLabel: 'YYYY-MM-DD'
  }
};

@Component({
  selector: 'app-dynamic-form-contenido',
  templateUrl: './dynamic-form-contenido.component.html',
  styleUrls: ['./dynamic-form-contenido.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class DynamicFormContenidoComponent implements OnInit {
  @Input() item: EstructuraBase<any>;
  //@Input() destino:string;
  @Input() form: FormGroup;

  id: number;
  dataFiltered: any[];
  cargando = false;
  minDatePadre = new Date(2010, 1, 1);
  maxDatePadre = new Date(2020, 0, 1);
  minDateHijo = new Date(2010, 1, 1);
  maxDateHijo = new Date(2020, 0, 1);
  dateController1 = true;
  dateController2 = true;
  nombre = 'jose';

  constructor(private servicioCargaInformacion: DropdownService) {}

  ngOnInit() {
    //alert(JSON.stringify(this.item));
    /*$(document).ready(function(){
      $(".fecha-calendar").datepicker({
        dateFormat: 'yy-mm-dd',
        onSelect: function(fechaParam) {
         let elemento = $(this).attr('id');
         let tipo = $(this).attr("data-title");


         if (tipo == 'padre') {
          let fechaHijo = this.form.controls[elemento].value;
          let fechaPadre = fechaParam;
          if (fechaPadre > fechaHijo) {//SI LA FECHA INICIAL ES IGUAL

          }

          let minDate = $(this).datepicker('getDate');
          alert(minDate);
          $("#"+elemento).datepicker( "option", "minDate", minDate);
        }
        else if (tipo == 'hijo') {
          let fechaPadre = this.form.controls[elemento].value;
          let fechaHijo = fechaParam;


        }


        }
      });



      $(".fecha-calendar").datepicker().datepicker("setDate", new Date());

    });*/
  }

  /*ngAfterViewInit(): void {
    $.widget("custom.combobox", {
      _create: function () {
        this.wrapper = $("<span>")
          .addClass("custom-combobox")
          .insertAfter(this.element);

        this.element.hide();
        this._createAutocomplete();
        this._createShowAllButton();
      },

      _createAutocomplete: function () {
        var selected = this.element.children(":selected"),
          value = selected.val() ? selected.text() : "";

        this.input = $("<input>")
          .appendTo(this.wrapper)
          .val(value)
          .attr("title", "")
          .addClass("custom-combobox-input ui-widget ui-widget-content ui-state-default ui-corner-left")
          .autocomplete({
            delay: 0,
            minLength: 0,
            source: $.proxy(this, "_source")
          })
          .tooltip({
            classes: {
              "ui-tooltip": "ui-state-highlight"
            }
          });

        this._on(this.input, {
          autocompleteselect: function (event, ui) {
            ui.item.option.selected = true;
            this._trigger("select", event, {
              item: ui.item.option
            });
          },

          autocompletechange: "_removeIfInvalid"
        });
      },

      _createShowAllButton: function () {
        var input = this.input,
          wasOpen = false;

        $("<a>")
          .attr("tabIndex", -1)
          .attr("title", "Show All Items")
          .tooltip()
          .appendTo(this.wrapper)
          .button({
            icons: {
              primary: "ui-icon-triangle-1-s"
            },
            text: false
          })
          .removeClass("ui-corner-all")
          .addClass("custom-combobox-toggle ui-corner-right")
          .on("mousedown", function () {
            wasOpen = input.autocomplete("widget").is(":visible");
          })
          .on("click", function () {
            input.trigger("focus");

            // Close if already visible
            if (wasOpen) {
              return;
            }

            // Pass empty string as value to search for, displaying all results
            input.autocomplete("search", "");
          });
      },

      _source: function (request, response) {
        var matcher = new RegExp($.ui.autocomplete.escapeRegex(request.term), "i");
        response(this.element.children("option").map(function () {
          var text = $(this).text();
          if (this.value && (!request.term || matcher.test(text)))
            return {
              label: text,
              value: text,
              option: this
            };
        }));
      },

      _removeIfInvalid: function (event, ui) {

        // Selected an item, nothing to do
        if (ui.item) {
          return;
        }

        // Search for a match (case-insensitive)
        var value = this.input.val(),
          valueLowerCase = value.toLowerCase(),
          valid = false;
        this.element.children("option").each(function () {
          if ($(this).text().toLowerCase() === valueLowerCase) {
            this.selected = valid = true;
            return false;
          }
        });

        // Found a match, nothing to do
        if (valid) {
          return;
        }

        // Remove invalid value
        this.input
          .val("")
          .attr("title", value + " didn't match any item")
          .tooltip("open");
        this.element.val("");
        this._delay(function () {
          this.input.tooltip("close").attr("title", "");
        }, 2500);
        this.input.autocomplete("instance").term = "";
      },

      _destroy: function () {
        this.wrapper.remove();
        this.element.show();
      }
    });

    $(".combobox").combobox();
    $("#toggle").on("click", function () {
      $(".combobox").toggle();
    });
  }*/

  cargaDropDown(origenDatos, opt, label) {
    //alert(origenDatos);
    this.id = this.form.get(opt).value;
    //alert(origenDatos);
    //this.form.get(origenDatos)
    //alert(JSON.stringify(this.form.get(origenDatos)));
    this.cargando = true;
    this.servicioCargaInformacion
      .getData(origenDatos, this.id)
      .subscribe(data => {
        //this.dataFiltered=data;
        //alert(origenDatos);

        /*$("#" + origenDatos)
          .empty();*/
        $('#' + origenDatos)
          .find('option')
          .not(':first')
          .remove();
        /*$("#" + origenDatos)
        .append('<option value="" disabled selected>' + label + '</option>');*/
        data.forEach(element => {
          $('#' + origenDatos).append(
            '<option value="' + element.id + '">' + element.valor + '</option>'
          );
        });
        //$("#"+origenDatos+" option:eq(0)").attr("selected","selected");
        $('#' + origenDatos).val('');
        this.form.controls[origenDatos].setValue('');
        this.cargando = false;
        //$("#" + origenDatos).selectmenu().selectmenu('refresh', true);
      });
  }

  setValue() {}

  seleccionaFecha(event, tipo, elemento) {
    if (tipo == 'padre') {
      let fechaHijo = this.form.controls[elemento].value;
      let fechaPadre = event.value;
      if (fechaPadre > fechaHijo) {
        //SI LA FECHA INICIAL ES IGUAL
        this.form.controls[elemento].setValue(fechaPadre);
      }

      this.minDateHijo = new Date(2019, 1, 23);
      //alert(this.minDateHijo);
    } else if (tipo == 'hijo') {
      let fechaPadre = this.form.controls[elemento].value;
      let fechaHijo = event.value;
    }
  }

  padre(event, tipo, elemento) {
    //this.minDateHijo = new Date(2019, 1, 19);
    //this.minDatePadre = new Date(2019, 1, 15);
    //this.nombre="Pablo";
    //alert("aqui");
    /*setTimeout(function () {
      this.dateController2=true;
   }, 300);*/
    //alert(event.value);
    //event.stopPropagation();
    /*alert(event.value);
    alert(this.form.controls[elemento].value);
    let fechaPadre = _moment(event.value).format('YYYY-MM-DD');
    if(fechaPadre>this.form.controls[elemento].value){
      alert("fecha inicial mayor a fecha final");
    }*/
  }

  get isValid() {
    return this.form.controls[this.item.key].valid;
  }

  get Error() {
    // alert(this.form.controls[this.item.key].errors);
    return this.form.controls[this.item.key].errors;
  }
}
